var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningTriangle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9294_99919",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9294_99919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.40112 14.5007C1.63078 14.5007 1.14972 13.6663 1.53569 12.9996L7.13457 3.32881C7.51974 2.66353 8.48026 2.66353 8.86543 3.32881L14.4643 12.9996C14.8503 13.6663 14.3692 14.5007 13.5989 14.5007H2.40112ZM8 12.5007C8.18889 12.5007 8.34722 12.4368 8.475 12.309C8.60278 12.1812 8.66667 12.0229 8.66667 11.834C8.66667 11.6451 8.60278 11.4868 8.475 11.359C8.34722 11.2312 8.18889 11.1673 8 11.1673C7.81111 11.1673 7.65278 11.2312 7.525 11.359C7.39722 11.4868 7.33333 11.6451 7.33333 11.834C7.33333 12.0229 7.39722 12.1812 7.525 12.309C7.65278 12.4368 7.81111 12.5007 8 12.5007ZM7.33333 9.83399C7.33333 10.2022 7.63181 10.5007 8 10.5007C8.36819 10.5007 8.66667 10.2022 8.66667 9.83398V7.83398C8.66667 7.46579 8.36819 7.16732 8 7.16732C7.63181 7.16732 7.33333 7.46579 7.33333 7.83398V9.83399Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangle);
export default __webpack_public_path__ + "static/media/warning-triangle.5da30f57c3c3daa10ee01fbb8d92de05.svg";
export { ForwardRef as ReactComponent };